<template>
  <div
    class="letter-report w-full h-screen bg-cover relative text-xl overflow-hidden"
  >
    <div
      class="absolute w-screen h-screen z-10 opacity-20 overflow-hidden pointer-events-none"
    >
      <div
        v-for="(item, index) in watermarks"
        :key="index"
        class="absolute text-center text-6xl font-bold text-gray-300 whitespace-nowrap"
        :style="{
          top: `${item.top}%`,
          left: `${item.left}%`,
          transform: 'rotate(-30deg)',
        }"
      >
        {{ item.text }}
      </div>
    </div>
    <div class="fixed right-0 bottom-0 pb-10 pr-5 print:hidden z-50">
      <el-button
        onclick="window.print()"
        type="primary"
        size="medium"
        class="transform scale-150"
        >打印</el-button
      >
    </div>
    <img
      class="absolute inset-0 w-full h-full opacity-60"
      style="z-index: 0"
      :src="bgSrc"
      alt=""
    />
    <div class="container mx-auto pt-5">
      <div class="checked-reporter-card bg-opacity-60 bg-white">
        <div
          class="arrow mx-auto text-3xl text-white bg-blue-bg w-4/5 2xl:w-3/5 h-40 flex flex-col justify-end align-center"
        >
          <div
            class="text-center text-2xl text-blue-level transform scale-x-80 whitespace-nowrap"
          >
            吉林市国家级中小企业数字化转型试点城市企业数字化水平
          </div>
          <span class="text-center pb-7 pt-2 text-black font-bold"
            >自评测结果</span
          >
        </div>
        <div class="grid grid-cols-5 mx-20 text-sm">
          <div class="col-span-1 flex flex-col text-center">
            <div class="text-blue-level">评测时间</div>
            <div class="font-bold">
              {{ (detail.createAt || "").substring(0, 10) }}
            </div>
          </div>
          <div class="col-span-3 flex flex-col text-center">
            <div class="text-blue-level">企业名称</div>
            <div class="font-bold whitespace-nowrap">
              {{ info.enterpriseName }}
            </div>
          </div>
          <div class="col-span-1 flex flex-col text-center">
            <div class="text-blue-level">统一社会信用代码</div>
            <div class="font-bold">{{ staff.enterpriseCode }}</div>
          </div>
        </div>
        <div class="mx-auto">
          <span class="text-4xl text-blue-500 font-bold">{{
            levelName[2] === 0
              ? levelName[1]
              : `${levelName[1]}（${levelName[0]}）`
          }}</span>
        </div>
        <div class="mx-16 text-sm" v-if="detail.sceneAnswers">
          <div class="grid grid-cols-25 space-x-3 leading-none">
            <div
              class="col-span-12 grid grid-cols-12 border border-solid border-black"
            >
              <div class="col-span-12 grid grid-cols-11">
                <div class="col-span-10 grid grid-cols-10 bg-blue-bg">
                  <div
                    class="col-span-1 border-b border-r border-solid border-black flex flex-col justify-center items-center py-1"
                  >
                    <span>一</span><span>级</span><span>指</span><span>标</span>
                  </div>
                  <div
                    class="col-span-9 grid grid-cols-9 border-b border-solid border-black"
                  >
                    <div
                      class="col-span-4 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      A
                    </div>
                    <div
                      class="col-span-2 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      B
                    </div>
                    <div
                      class="col-span-3 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      C
                    </div>
                    <div
                      class="col-span-4 border-r border-solid border-black flex flex-col items-center justify-center pb-1"
                    >
                      <div>数字化</div>
                      <div>基础</div>
                    </div>
                    <div
                      class="col-span-2 border-r border-solid border-black flex flex-col items-center justify-center pb-1"
                    >
                      <div>数字化</div>
                      <div>管理</div>
                    </div>
                    <div
                      class="col-span-3 border-r border-solid border-black flex flex-col items-center justify-center pb-1"
                    >
                      <div>数字化</div>
                      <div>成效</div>
                    </div>
                  </div>
                  <div
                    class="cols-span-1 border-b border-r border-solid border-black flex flex-col justify-center items-center py-1"
                  >
                    <span>二</span><span>级</span><span>指</span><span>标</span>
                  </div>
                  <div class="col-span-9 grid grid-cols-9 bg-gray-bg">
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>设</span><span>备</span><span>系</span
                      ><span>统</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>数</span><span>据</span><span>采</span
                      ><span>集</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>信</span><span>息</span><span>系</span
                      ><span>统</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>信</span><span>息</span><span>安</span
                      ><span>全</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>规</span><span>划</span><span>管</span
                      ><span>理</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>要</span><span>素</span><span>保</span
                      ><span>障</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>绿</span><span>色</span><span>低</span
                      ><span>碳</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>产</span><span>品</span><span>质</span
                      ><span>量</span>
                    </div>
                    <div
                      class="col-span-1 border-b border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <span>市</span><span>场</span><span>效</span
                      ><span>益</span>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-1 border-b border-solid border-black flex flex-col items-center justify-center bg-blue-bg"
                >
                  <div>综</div>
                  <div>合</div>
                  <div>得</div>
                  <div>分</div>
                </div>
                <div
                  class="cols-span-1 border-r border-solid border-black flex flex-col justify-center items-center bg-blue-bg"
                  :class="detail.levelName === '无等级' ? 'py-2' : 'py-1'"
                >
                  <span class="leading-none">得</span><span>分</span>
                </div>
                <div
                  class="col-span-10 grid grid-cols-10 text-blue-level text-xs font-arial"
                >
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partOne * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partTwo * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partThree * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partFour * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partFive * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partSix * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partSeven * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partEight * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-r border-solid border-black flex justify-center items-center overflow-hidden"
                  >
                    {{ detail.partNine * 1 || 0 }}
                  </div>
                  <div
                    class="col-span-1 border-solid border-black flex justify-center items-center overflow-hidden bg-blue-bg text-black"
                  >
                    {{ (detail.score * 1 || 0).toFixed(3) * 1 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-13 grid grid-cols-18">
              <div
                class="col-span-18 grid grid-cols-18 border border-solid border-black"
              >
                <div class="col-span-17 grid grid-cols-17">
                  <div
                    class="col-span-1 border-b border-r border-solid border-black flex flex-col justify-center items-center bg-blue-bg pb-1"
                  >
                    <span>一</span><span>级</span><span>指</span><span>标</span>
                  </div>
                  <div
                    class="col-span-16 border-b border-solid border-black grid grid-cols-16 bg-blue-bg"
                  >
                    <div
                      class="col-span-4 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      D
                    </div>
                    <div
                      class="col-span-6 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      E
                    </div>
                    <div
                      class="col-span-2 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      F
                    </div>
                    <div
                      class="col-span-4 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      G
                    </div>
                    <div
                      class="col-span-4 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <div>产品生命周期</div>
                      <div>数字化</div>
                    </div>
                    <div
                      class="col-span-6 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <div>生产执行</div>
                      <div>数字化</div>
                    </div>
                    <div
                      class="col-span-2 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <div>供应链</div>
                      <div>数字化</div>
                    </div>
                    <div
                      class="col-span-4 border-r border-solid border-black flex flex-col items-center justify-center"
                    >
                      <div>管理决策</div>
                      <div>数字化</div>
                    </div>
                  </div>
                  <div
                    class="cols-span-1 border-b border-r border-solid border-black flex flex-col justify-center items-center bg-blue-bg pb-1"
                  >
                    <span>二</span><span>级</span><span>指</span><span>标</span>
                  </div>
                  <div
                    class="col-span-16 grid grid-cols-16 border-b border-solid border-black"
                  >
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>产</span><span>品</span><span>设</span
                      ><span>计</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-none"
                    >
                      <span>工</span><span>艺</span><span>设</span
                      ><span>计</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>营</span><span>销</span><span>管</span
                      ><span>理</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-none"
                    >
                      <span>售</span><span>后</span><span>服</span
                      ><span>务</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-none"
                    >
                      <span>计</span><span>划</span><span>排</span
                      ><span>程</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>生</span><span>产</span><span>管</span
                      ><span>控</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>质</span><span>量</span><span>管</span
                      ><span>理</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>设</span><span>备</span><span>管</span
                      ><span>理</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>安</span><span>全</span><span>生</span
                      ><span>产</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>能</span><span>耗</span><span>管</span
                      ><span>理</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>采</span><span>购</span><span>管</span
                      ><span>理</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>仓</span><span>储</span><span>物</span
                      ><span>流</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-gray-bg"
                    >
                      <span>财</span><span>务</span><span>管</span
                      ><span>理</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-none"
                    >
                      <span>人</span><span>力</span><span>资</span
                      ><span>源</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-none"
                    >
                      <span>协</span><span>同</span><span>办</span
                      ><span>公</span>
                    </div>
                    <div
                      class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center bg-none"
                    >
                      <span>决</span><span>策</span><span>支</span
                      ><span>持</span>
                    </div>
                  </div>
                </div>
                <div
                  class="col-span-1 border-b border-solid border-black flex flex-col items-center justify-center bg-blue-bg"
                >
                  <div>综</div>
                  <div>合</div>
                  <div>等</div>
                  <div>级</div>
                </div>
                <div
                  class="cols-span-1 border-r border-solid border-black flex flex-col justify-center items-center bg-blue-bg"
                >
                  <span>等</span><span>级</span>
                </div>
                <div class="col-span-17 grid grid-cols-17 text-blue-level">
                  <div
                    class="col-span-1 border-r border-solid border-black flex flex-col items-center justify-center"
                    v-for="item in detail.sceneAnswers"
                  >
                    <template v-if="item.level">
                      <div>{{ item.levelName }}</div>
                      <div>级</div>
                    </template>
                    <template v-else>
                      <div>&nbsp;</div>
                    </template>
                  </div>
                  <div
                    class="col-span-1 border border-solid border-blue-bg flex flex-col items-center justify-center bg-blue-bg text-black"
                  >
                    <template v-if="detail.levelName === '无等级'">
                      <div class="text-xs leading-none">无</div>
                      <div class="text-xs leading-none">等</div>
                      <div class="text-xs leading-none">级</div>
                    </template>
                    <template v-else>
                      <div>{{ detail.levelName.replace("级", "") }}</div>
                      <div>级</div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="pt-2 text-xs text-center">
            以上结果是试点企业通过“吉林市中小企业数字化水平评测系统”自行评测得出的。
          </p>
          <p class="text-xs text-center">
            该系统由吉林市工业和信息化局正式委托的第三方评测机构提供，其依据为工业和信息化部《中小企业数字化水平评测指标（2024年版）》。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/app.css";
import { getInfo } from "@/api/enterprise";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      watermarks: generateWatermarks(),
      loading: true,
      bgSrc: "/buckets/static_images/picture31.png",
      info: {},
      detail: {},
    };
  },
  computed: {
    ...mapGetters(["staff"]),
    levelName() {
      return (
        [
          ["无等级", "无等级", 0],
          ["初始级", "一级", 1],
          ["规范级", "二级", 2],
          ["集成级", "三级", 3],
          ["协同级", "四级", 4],
        ].find((v) => v[0] === this.detail.levels) || ["无等级", "无等级", 0]
      );
    },
  },
  created() {
    if (!window.opener) {
      window.close();
    }
    this.loadInfo();
  },
  mounted() {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/buckets/fonts/text.css";
    document.head.appendChild(link);

    window.addEventListener("message", this.handleMessage);
    window.opener.postMessage("getLetterOwnerReport");
  },
  destroyed() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    loadInfo() {
      getInfo({ userId: this.staff.id }).then((res) => {
        this.info = res.data;
      });
    },
    handleMessage({ data }) {
      this.loading = false;
      this.detail = JSON.parse(data);
      console.log("detail", this.detail);
      this.detail.sceneAnswers = this.detail.sceneAnswers
        .map((v) =>
          Object.assign({}, v, { quesId: v.quesId * 1, ans: JSON.parse(v.ans) })
        )
        .map((v) =>
          Object.assign(v, {
            ans: v.ans,
            level: v.ans.length,
            levelName: ["无等", "一", "二", "三", "四"][v.ans.length],
          })
        );
      window.removeEventListener("message", this.handleMessage);
    },
  },
};

function generateWatermarks() {
  const rows = 5;
  const cols = 5;
  const watermarks = [];

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      watermarks.push({
        top: i * 30,
        left: j * 30,
        text: process.env.VUE_APP_TITLE,
      });
    }
  }

  return watermarks;
}
</script>

<style scoped>
.checked-reporter-card {
  @apply flex flex-col justify-center space-y-10 relative pb-20 border border-white rounded-2xl overflow-hidden;
}
.checked-reporter-card::before {
  content: "";
  @apply absolute inset-0 border border-blue-600 rounded-2xl m-10 mt-8 z-10;
}
.checked-reporter-card::after {
  content: "";
  @apply absolute inset-0 border border-blue-600 rounded-2xl m-12 mt-10;
}
.arrow {
  background: linear-gradient(
    45deg,
    rgba(59, 130, 246, 0.5),
    rgba(59, 130, 246, 0.5)
  );
  clip-path: polygon(0 0, 0 50%, 50% 100%, 100% 50%, 100% 0);
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
}
</style>
